import {Component} from '@angular/core';
import {Router} from '@angular/router';
import {Observable} from 'rxjs';
import {PotService} from '../pot.service';
import {LocationWithVoorraad} from '../location-with-voorraad';
import {PotStock} from '../pot';
import {SortingService} from '../../../_services/sorting.service';
import {AbstractLocationCountComponent} from '../../common/abstract-location-count.component';

@Component({
  selector: 'app-pot-count-priority',
  templateUrl: './pot-count-priority.component.html',
  styleUrls: ['./pot-count-priority.component.scss']
})
export class PotCountPriorityComponent extends AbstractLocationCountComponent<PotStock> {
  protected readonly detailRoutePrefix = '/voorraad/potten';

  constructor(
    private potService: PotService,
    router: Router,
    sortingService: SortingService
  ) {
    super(router, sortingService);
  }

  protected fetchLocations(): Observable<LocationWithVoorraad[]> {
    return this.potService.getAllStockRequireCounting();
  }

  protected fetchStockItemById(id: number): Observable<PotStock> {
    return this.potService.getStockById(id);
  }

  protected updateStockItem(stock: PotStock): Observable<PotStock> {
    return this.potService.updateStock(stock);
  }
}
